import { render } from "./NewDocumentsFolder.vue?vue&type=template&id=2e15331c&scoped=true"
import script from "./NewDocumentsFolder.vue?vue&type=script&lang=js"
export * from "./NewDocumentsFolder.vue?vue&type=script&lang=js"

import "./NewDocumentsFolder.vue?vue&type=style&index=0&id=2e15331c&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e15331c"]])

export default __exports__